import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Web3Service } from '../../services/web3.service';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-not-connected',
  templateUrl: './not-connected.component.html',
  styleUrls: ['./not-connected.component.scss']
})
export class NotConnectedComponent {
  @Input() description: string = 'Connect a wallet to get started.';

  constructor(private web3Service: Web3Service) {}

  connect(): void {
    this.web3Service.connect();
  }
}

